import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import WifiIcon from "@mui/icons-material/Wifi";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";
import LinkIcon from "@mui/icons-material/Link";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import {devices, organizations} from "../../mock/data";
import { Link } from "react-router-dom";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import {MaterialReactTable} from "material-react-table";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {useMaterialUIController} from "../../context";

function Devices() {
  const [searchTerm, setSearchTerm] = useState("");
  const [controller] = useMaterialUIController();

  const { darkMode } = controller;
  const theme = createTheme({
    components: {
      MuiTablePagination: {
        styleOverrides: {
          root: {
            backgroundColor: "#f5f5f5", // Change pagination background color
            color: "#000", // Change pagination text color
          },
          selectIcon: {
            color: "#000", // Change dropdown icon color
          },
        },
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            color: "#000", // Change color of icons (e.g., sorting icons)
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            color: "#000", // Change search input text color
          },
        },
      },
    },
  });
  // serialNumber: "4G200200390",
  //     model: "SG304GB",
  //     name: "בקר אתחול ופתיחה - יוקלר ראשי",
  //     address: "חטיבה תשע 1, עפולה, Israel",
  //     status: "Connected",
  //     health: {
  //   connectionStability: 50,
  //       signalQuality: 40,
  //       voltageStability: 100,
  //       signalNoise: 25,
  // },

  const deviceColumns = [
    {
      header: "Serial Number",
      accessorKey: "serialNumber",
    },
    {
      header: "Model",
      accessorKey: "model",
    },
    {
      header: "Name",
      accessorKey: "name",
    },
    {
      header: "Address",
      accessorKey: "address",
    },
    {
      header: "Status",
      accessorKey: "status",
      // For a custom cell, MaterialReactTable passes `cell`, `row`, `column`, etc.
      // We only need `row.original` if we want to read the original row data.
      Cell: ({ row }) => {
        const statusText = row.original.status;
        const statusLower = statusText?.toLowerCase();

        let style = {
          backgroundColor: "gray",
          color: "white",
          padding: "6px 10px",
          borderRadius: "4px",
          display: "inline-block",
          textAlign: "center",
        };

        if (statusLower === "connected") {
          style.backgroundColor = "green";
        } else if (statusLower === "disconnected") {
          style.backgroundColor = "red";
        }

        return <span style={style}>{statusText}</span>;
      },
    },
    {
      header: "Health",
      accessorKey: "health",
      Cell: ({ row }) => {
        const health = row.original.health;
        return (
            <div style={{display: "flex", gap: "8px", justifyContent: "center"}}>
              <Tooltip title={`Connection stability: ${health.connectionStability}%`} arrow>
                <WifiIcon style={{color: health.connectionStability > 50 ? "green" : "orange"}}/>
              </Tooltip>
              <Tooltip title={`Signal quality: ${health.signalQuality}%`} arrow>
                <SignalCellularAltIcon
                    style={{color: health.signalQuality > 50 ? "green" : "orange"}}
                />
              </Tooltip>
              <Tooltip title={`Voltage stability: ${health.voltageStability}%`} arrow>
                <ElectricalServicesIcon
                    style={{color: health.voltageStability > 50 ? "green" : "red"}}
                />
              </Tooltip>
              <Tooltip title={`Signal noise: ${health.signalNoise}%`} arrow>
                <LinkIcon style={{color: health.signalNoise > 50 ? "orange" : "green"}}/>
              </Tooltip>
            </div>
        );
      },
    },
  ];

  const filteredDevices = devices.filter(
      (device) =>
          device.serialNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
          device.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          device.address.toLowerCase().includes(searchTerm.toLowerCase()) ||
          device.model.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const searchRowRecursively = (row, columnId, filterValue) => {
    const value = row.getValue(columnId);

    // If the current row matches, return true
    if (value?.toLowerCase().includes(filterValue.toLowerCase())) {
      return true;
    }

    // If the current row has subRows, search them too
    if (row.subRows?.length) {
      return row.subRows.some((subRow) => searchRowRecursively(subRow, columnId, filterValue));
    }

    return false;
  };

  return (
      <DashboardLayout>
        <DashboardNavbar/>
        <Grid style={{marginTop: "1%"}} container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Devices
                </MDTypography>
              </MDBox>
              <MDBox pt={3} px={2}>
            </MDBox>
            <MDBox pt={3}>
              {/*<DataTable*/}
              {/*  table={{*/}
              {/*    columns: deviceColumns,*/}
              {/*    rows: filteredDevices,*/}
              {/*  }}*/}
              {/*  isSorted={false}*/}
              {/*  entriesPerPage={false}*/}
              {/*  showTotalEntries={false}*/}
              {/*  noEndBorder*/}
              {/*/>*/}
              <ThemeProvider theme={theme}>

              <MaterialReactTable
                  columns={deviceColumns}
                  data={devices}
                  enableExpanding
                  // muiBottomToolbarProps={{
                  //   sx: {
                  //     backgroundColor: darkMode ? '#1e293b' : '#0098CF',
                  //   },
                  // }}
                  muiBottomToolbarProps={{
                    sx: {
                      backgroundColor: darkMode ? '#1e293b' : '#fff',
                      color: darkMode ? '#fff' : '#1e293b',
                      ".MuiFormLabel-root": {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                      ".MuiSelect-icon": {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                      ".MuiSelect-select": {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                      ".MuiBox-root.MuiButtonBase-root" : {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                      ".MuiSvgIcon-root" : {
                        color: darkMode ? '#fff' : '#1e293b',
                      },
                      '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                        // pick a dimmer color for disabled icons
                        color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      },
                    }
                  }}
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: darkMode ? '#1e293b' : '#fff',
                      color: '#fff',
                      ".MuiSvgIcon-root" : {

                        color: darkMode ? '#fff' : '#1e293b',

                      },

                      '& .MuiInputBase-input': {
                        color: darkMode ? '#fff' : '#1e293b',
                      }
                    },

                  }}
                  muiTableBodyCellProps={{
                    sx: {
                      backgroundColor: darkMode ? "#1e293b;" : "#ffffff",
                      color: darkMode ? "#ffffff" : "#000",
                      ".MuiSvgIcon-root" : {
                        color: darkMode ? "#ffffff" : "#000",
                      }
                    },
                  }}
                  muiTableHeadCellProps={{
                    sx: {
                      backgroundColor: darkMode ? "#1e293b" : "#0098CF",
                      color: "white",
                      fontWeight: "bold",
                      ".MuiSvgIcon-root" : {
                        color: darkMode ? "#ffffff" : "#000",
                      },
                      // then specifically target the sort label icon:
                      '& .MuiTableSortLabel-icon': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      // likewise for iconDirectionAsc / iconDirectionDesc if needed
                      '& .MuiTableSortLabel-iconDirectionAsc': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiTableSortLabel-iconDirectionDesc': {
                        color: darkMode ? '#fff !important' : '#000 !important',
                      },
                      '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                        // pick a dimmer color for disabled icons
                        color: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      },
                      '& .MuiInputBase-input': {
                      color: darkMode ? '#fff' : '#1e293b',
                    }
                    },
                  }}
                  globalFilterFn="recursiveSearch"
                  filterFns={{
                    recursiveSearch: (row, columnId, filterValue) => {
                      return searchRowRecursively(row, columnId, filterValue);
                    },
                  }}
                  muiTableHeadProps={{
                    sx: {
                      display: "table-header-group", // Ensure proper table header display
                      backgroundColor: "rgb(0,255,234)",
                      color: "white",
                    },
                  }}
                  initialState={{
                    expanded: false,
                  }}
                  muiTableContainerProps={{
                    sx: {
                      width: "100%",
                      overflowX: "auto",
                      backgroundColor: "#15aff4",
                      color: "white",
                    },
                  }}
                  getSubRows={(row) => row?.subRows ?? []}
              />
              </ThemeProvider>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
}

export default Devices;
